import { en } from './translations/en';
import { pt } from './translations/pt';
import { es } from './translations/es';
import { fr } from './translations/fr';
import { ja } from './translations/ja';

export const translations = {
  pt,
  en,
  es,
  fr,
  ja,
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;
